/**
 * AV telemetry envelope — the cross-track schema shared with the ingest API. No business
 * identifiers belong here; identity is attached server-side at ingest.
 */

/** Bump when the SPINE changes shape. Payload changes are the translator's problem. */
export const AV_TELEMETRY_SCHEMA_VERSION = 1;

/** `tickAggregate` is a collapsed window of ticks, produced when the buffer sheds. */
export type AvTelemetryRecordType = 'meta' | 'tick' | 'event' | 'tickAggregate';

export type AvTelemetryVendor = 'chime' | 'vonage';

export type AvTelemetryCadenceMode = 'push' | 'poll';

export const AV_TELEMETRY_POLL_INTERVAL_MS = 1_000;

export interface AvTelemetryEnvelope<TPayload = unknown> {
  type: AvTelemetryRecordType;
  schemaVersion: number;
  occurredAt: number;
  vendor: AvTelemetryVendor;
  vendorVersion: string;
  seq: number;
  payload: TPayload;
}

export interface AvTelemetryClientHints {
  brands: { brand: string; version: string }[] | null;
  mobile: boolean | null;
  platform: string | null;
}

export interface AvTelemetryClientContext {
  userAgent: string;
  clientHints: AvTelemetryClientHints;
  language: string;
  hardwareConcurrency: number | null;
  deviceMemoryGb: number | null;
  screenWidth: number | null;
  screenHeight: number | null;
  devicePixelRatio: number | null;
  /**
   * Origin storage as the browser reports it, so the buffer's byte budget can be checked against
   * the real device fleet rather than an estimate. Null where the API is unavailable.
   */
  storageQuotaBytes: number | null;
  storageUsageBytes: number | null;
}

/** Read asynchronously, so it is gathered before the source is built rather than inside it. */
export interface AvTelemetryStorageEstimate {
  quotaBytes: number | null;
  usageBytes: number | null;
}
